(() => {
  'use strict';
  const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  document.querySelectorAll('[data-gummy-price-calculator]').forEach(root => {
    if (root.dataset.calculatorReady) return;
    root.dataset.calculatorReady = 'true';
    const form = root.querySelector('form');
    const result = root.querySelector('[data-gummy-calculator-result]');
    form.addEventListener('input', () => { result.textContent = ''; });
    form.addEventListener('change', () => { result.textContent = ''; });
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      const fields = form.elements;
      const ownOption = fields.ourPack.selectedOptions[0];
      const ownCount = Number(ownOption?.dataset.count);
      const ownTotal = Number(ownOption?.value) / 100 + Number(fields.ourShipping.value || 0);
      const otherCount = Number(fields.otherCount.value);
      const otherTotal = Number(fields.otherPrice.value) + Number(fields.otherShipping.value || 0);
      if (![ownCount, ownTotal, otherCount, otherTotal].every(Number.isFinite) || ownCount <= 0 || otherCount <= 0 || !Number.isInteger(otherCount) || ownTotal < 0 || otherTotal <= 0) {
        result.textContent = 'Enter a valid pack price and a whole number of gummies.';
        return;
      }
      const ownUnit = ownTotal / ownCount;
      const otherUnit = otherTotal / otherCount;
      const difference = (otherUnit - ownUnit) / otherUnit * 100;
      const comparison = Math.abs(difference) < 0.05 ? 'The cost per gummy is the same.' :
        difference > 0 ? `Kratom Paradise costs ${difference.toFixed(1)}% less per gummy.` :
        `The other pack costs less per gummy; Kratom Paradise is ${Math.abs(difference).toFixed(1)}% higher.`;
      result.textContent = `Kratom Paradise: ${money.format(ownUnit)} per gummy (${money.format(ownTotal)} for ${ownCount}). Other brand: ${money.format(otherUnit)} per gummy (${money.format(otherTotal)} for ${otherCount}). ${comparison} Before tax; includes only the shipping you entered.`;
    });
  });
})();
